import React, { useState } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Badge,
  Text,
  IconButton,
  Tooltip,
  HStack
} from '@chakra-ui/react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

function AuditLogTable({ auditLogs }) {
  const [visibleRows, setVisibleRows] = useState({});

  const toggleVisibility = (id) => {
    setVisibleRows(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  if (!Array.isArray(auditLogs) || auditLogs.length === 0) {
    return <Box p={4}>No audit logs found.</Box>;
  }

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="sm" width="100%">
      <Box maxW="100%" overflowX="auto">
        <Table 
          variant="simple" 
          size="sm" 
          borderWidth="1px" 
          borderColor="gray.200" 
          _dark={{ borderColor: "gray.600" }}
        >
          <Thead>
            <Tr>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>Date</Th>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>User</Th>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>File</Th>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>Variable</Th>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>Previous Value</Th>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>Current Value</Th>
              <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {auditLogs.map((log) => {
              const fileName = log.file_path.split('/').pop();
              return (
                <Tr key={log.id}>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                  >
                    {formatDate(log.created_at)}
                  </Td>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                  >
                    {log.user.name}
                  </Td>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                  >
                    <Badge colorScheme="blue">{fileName}</Badge>
                    <Text fontSize="xs" color="gray.500" mt={1}>
                      {log.file_path}
                    </Text>
                  </Td>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                    fontWeight="bold"
                  >
                    {log.variable_key}
                  </Td>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                  >
                    <Box maxW="150px" overflow="hidden" textOverflow="ellipsis">
                      {visibleRows[log.id] ? (
                        <Text fontSize="sm">{log.prev_value || '(none)'}</Text>
                      ) : (
                        <Text as="span" letterSpacing="2px" filter="blur(4px)" fontSize="sm">
                          {log.prev_value ? log.prev_value.replace(/./g, '•') : '(none)'}
                        </Text>
                      )}
                    </Box>
                  </Td>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                  >
                    <Box maxW="150px" overflow="hidden" textOverflow="ellipsis">
                      {visibleRows[log.id] ? (
                        <Text fontSize="sm">{log.current_value || '(none)'}</Text>
                      ) : (
                        <Text as="span" letterSpacing="2px" filter="blur(4px)" fontSize="sm">
                          {log.current_value ? log.current_value.replace(/./g, '•') : '(none)'}
                        </Text>
                      )}
                    </Box>
                  </Td>
                  <Td 
                    borderWidth="1px" 
                    borderColor="gray.200" 
                    _dark={{ borderColor: "gray.600" }}
                  >
                    <Tooltip label={visibleRows[log.id] ? "Hide values" : "Show values"}>
                      <IconButton
                        aria-label={visibleRows[log.id] ? "Hide values" : "Show values"}
                        icon={visibleRows[log.id] ? <FaEyeSlash /> : <FaEye />}
                        size="sm"
                        onClick={() => toggleVisibility(log.id)}
                      />
                    </Tooltip>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
}

export default AuditLogTable;